export default __webpack_public_path__ + "static/media/02-digitalization.5e7f622b.jpg";